/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

/**
 * Utility module for holding general common code between the main Enervee Angular applications.
 */

const commonModule = require('@utils/common/commonModule');
const consumersModule = require('@utils/consumers/consumersModule');
const GetFetchService = require('./getFetchService');

const getFetchModule = angular
    .module('enervee_utils.get_fetch', [
        commonModule.name,
        consumersModule.name,
    ])
    .factory('GetFetchService', GetFetchService);

module.exports = getFetchModule;
